import { useEffect, useState } from "react";

export default function useRolloverComputations({
  open,
  companyId,
  getTaxComputationList,
}) {
  const [result, setResult] = useState({});
  const [attempt, setAttempt] = useState(0);
  const key = JSON.stringify([companyId, attempt]);

  useEffect(() => {
    if (!open) {
      setResult({});
      return;
    }
    if (!companyId) return;

    const controller = new AbortController();
    setResult({ key, loading: true });
    getTaxComputationList(companyId, {
      skipMasExchangeRate: true,
      signal: controller.signal,
    })
      .then((computations) => {
        if (!controller.signal.aborted) {
          setResult({
            key,
            computations: Array.isArray(computations) ? computations : [],
          });
        }
      })
      .catch((error) => {
        if (controller.signal.aborted) return;
        setResult({
          key,
          error:
            typeof error === "string"
              ? error
              : error?.response?.data?.message ||
                error?.message ||
                "Unable to load previous year computations. Please try again.",
        });
      });
    return () => controller.abort();
  }, [open, companyId, getTaxComputationList, key]);

  return {
    computations: result.key === key ? result.computations || [] : [],
    loading: Boolean(
      open && companyId && (result.key !== key || result.loading)
    ),
    error:
      open && !companyId
        ? "The company is unavailable. Reopen the computation and try again."
        : result.key === key
          ? result.error
          : null,
    retry: () => setAttempt((value) => value + 1),
  };
}
